<template>
  <div class="issueLog">
    <el-dialog
      :title="$l('下发记录')"
      :visible.sync="dialogVisible"
      width="1130px"
      :close="close"
    >
      <panel>
        <el-table
          ref="singleTable"
          size="medium"
          tooltip-effect="tableTooltip"
          highlight-current-row
          v-loading.lock="loading"
          :data="tableData"
          max-height="400px"
        >
          <el-table-column
            type="index"
            :label="$l('序号')"
            min-width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            property="deviceNo"
            :label="$l('电梯工号')"
            min-width="120"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="effectiveDuration"
            :label="$l('有效时长(小时)')"
            min-width="120"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="startTimeSlot1"
            :label="$l('开始时间段') + 1"
            min-width="120"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="endTimeSlot1"
            :label="$l('结束时间段') + 1"
            min-width="120"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="startTimeSlot2"
            :label="$l('开始时间段') + 2"
            min-width="120"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="endTimeSlot2"
            :label="$l('结束时间段') + 2"
            min-width="120"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="issuer"
            :label="$l('下发人')"
            min-width="100"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="issueDate"
            :label="$l('下发时间')"
            min-width="200"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="issueContent"
            :label="$l('下发内容')"
            min-width="200"
            header-align="center"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <span
                style="
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                :title="scope.row.issueContent"
                >{{ scope.row.issueContent }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            property="auditStatus"
            :label="$l('审核状态')"
            min-width="120"
            header-align="center"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <span style="color: #909399" v-if="scope.row.auditStatus == 0">{{
                $l("待审核")
              }}</span>
              <span style="color: #67c23a" v-if="scope.row.auditStatus == 1">{{
                $l("审核通过")
              }}</span>
              <span style="color: #f56e6e" v-if="scope.row.auditStatus == 2">{{
                $l("审核不通过")
              }}</span>
              <span style="color: #e6a23c" v-if="scope.row.auditStatus == 3">{{
                $l("退回")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$l('审核')"
            min-width="80"
            header-align="center"
            align="center"
            fixed="right"
            v-if="hasPermission('审核')"
          >
            <template slot-scope="scope">
              <el-dropdown
                v-if="scope.row.auditStatus == 0"
                @command="(command) => audit(command, scope.row.issueId)"
                placement="bottom"
              >
                <span
                  style="cursor: pointer; color: #409eff"
                  class="el-icon-user-solid"
                >
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">{{
                    $l("审核通过")
                  }}</el-dropdown-item>
                  <el-dropdown-item command="2">{{
                    $l("审核不通过")
                  }}</el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.auditStatus != 3"
                    command="3"
                    >{{ $l("退回") }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column
            :label="$l('编辑')"
            min-width="80"
            header-align="center"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.auditStatus == 3"
                @click.native.prevent="showEdit(scope.row)"
                type="primary"
                clear
                icon="el-icon-edit-outline"
              >
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </el-dialog>
    <el-dialog
      ref="auditDialog"
      :title="$l('审核')"
      :visible.sync="auditDialogVisible"
    >
      <el-form
        ref="auditForm"
        label-width="140px"
        size="medium"
        v-model="auditForm"
      >
        <el-form-item :label="$l('审核状态')">
          <el-select v-model="auditForm.auditStatus">
            <el-option :label="$l('审核通过')" value="1"> </el-option>
            <el-option :label="$l('审核不通过')" value="2"> </el-option>
            <el-option :label="$l('退回')" value="3"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row type="flex">
          <el-col>
            <el-button round @click="auditDialogVisible = false"
              >{{ $l("取消") }}
            </el-button>
            <el-button round type="primary" @click="submitEdit"
              >{{ $l("确定") }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "issueLog",
  mixins: [global],
  components: {
    panel,
  },
  props: {},
  data() {
    return {
      form: {
        lcdId: "",
      },
      tableData: [],
      loading: false,
      dialogVisible: false,
      auditForm: {
        issueId: null,
        auditStatus: 1,
      },
      auditDialogVisible: false,
    };
  },
  methods: {
    open(lcdId) {
      this.form.lcdId = lcdId;
      this.dialogVisible = true;
      this.initData();
    },
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    initData() {
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_lcd_equipment_issue_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    audit(command, issueId) {
      this.confirmAlert(() => {
        this.auditForm.issueId = issueId;
        this.auditForm.auditStatus = command;
        this.$http
          .post(this.$apiConfig.lcd_equipment_audit_url, this.auditForm)
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.initData();
            }
          })
          .catch((error) => {
            this.errorMessage(0);
            this.$sentry.captureException(error);
          });
      }, "你确定要进行审核？");
    },
    showEdit(row) {
      this.$emit("onEdit", row);
    },
    update() {
      this.initData();
    },
    submitEdit() {
      alert(auditForm.auditStatus);
    },
    showDetail(row) {},
    close() {},
  },
};
</script>

<style lang="scss">
.issueLog {
  .el-dialog__wrapper {
    overflow: hidden !important;
  }
}
</style>
